<template>
  <div class="frame-wrapper work-history-show">
    <div class="filter-area-left">
      <div class="filter-icon-work" @click="onClickFilterWork"></div>
      <div class="filter-icon-location" @click="onClickFilterLocation"></div>
      <div class="filter-icon-paddy" @click="onClickArea"></div>
      <div
        class="filter-icon-search"
        @click="isShowSearchFrame = !isShowSearchFrame"
      ></div>
    </div>
    <div
      v-if="!isFilterFrameHidden"
      class="filter-frame-container"
      @click.self="hideFilterFrame"
    >
      <transition name="scale" appear>
        <div class="center-frame">
          <div class="top-frame">
            <div class="title-area">
              <h3 v-if="isFilterFrameWork" class="title-icon-work">
                作業を選択
              </h3>
              <h3 v-else-if="isFilterFrameLocation" class="title-icon-location">
                人を選択
              </h3>
            </div>
            <div>
              <div class="input-frame-wrap">
                <template v-if="isFilterFrameLocation">
                  <div class="location-date">
                    <input
                      v-model="selectedFilterLoation.locationDate"
                      type="date"
                      :min="selectedFilterLoation.dateMin"
                      :max="selectedFilterLoation.dateMax"
                    />
                    <select
                      v-model="selectedFilterLoation.startTime"
                      @change="onChangeLocationFilterStartTime"
                    >
                      <template v-for="(time, index) in filterTimes">
                        <option
                          :value="time"
                          :key="index"
                          v-if="index < filterTimes.length - 1"
                        >
                          {{ time }}
                        </option>
                      </template>
                    </select>
                    <span>〜</span>
                    <select
                      v-model="selectedFilterLoation.endTime"
                      @change="onChangeLocationFilterEndTime"
                    >
                      <template v-for="(time, index) in filterTimes">
                        <option :value="time" :key="index" v-if="index > 0">
                          {{ time }}
                        </option>
                      </template>
                    </select>
                  </div>
                  <div class="input-frame-C">
                    <template v-for="(user, index) in users">
                      <div class="user-info" :key="index">
                        <input
                          type="checkbox"
                          :id="'checkboxZ1-' + index"
                          :value="user.user_id"
                          v-model="selectedFilterLoation.users"
                        />
                        <label :for="'checkboxZ1-' + index" class="label">
                          {{ user.user_name }}</label
                        >
                        <div
                          class="user-color"
                          :style="{
                            backgroundColor: user.color,
                          }"
                        ></div>
                      </div>
                    </template>
                  </div>
                  <div class="button-area">
                    <div class="left-box" />
                    <div class="center-box">
                      <span
                        class="btn btn-submit active"
                        @click="onClickSearchLocation"
                        >設定</span
                      >
                    </div>
                    <div class="right-box"></div>
                  </div>
                </template>
                <template v-else-if="isFilterFrameWork">
                  <div class="input-frame">
                    <template v-for="season in seasons">
                      <input
                        type="radio"
                        :id="'checkbox-' + season.season_id"
                        :key="season.season_id"
                        :value="season.season_id"
                        name="season"
                        v-model="selectedSeasonId"
                        @click="onSelectSeason"
                      />
                      <label
                        :for="'checkbox-' + season.season_id"
                        class="label col3"
                        :key="'lbl' + season.season_id"
                        :style="getSeasonStyleObject(season.season_id)"
                        >{{ season.season_name }}</label
                      >
                    </template>
                  </div>

                  <div v-if="selectedSeasonId" class="input-frame-B">
                    <template v-for="item in selectedSeason.items">
                      <input
                        type="radio"
                        :id="'checkboxB-' + item.item_id"
                        :key="item.item_id"
                        :value="item.item_id"
                        name="item"
                        v-model="selectedItemId"
                        @change="onChangeItem"
                        @click="onClickItem"
                      />
                      <label
                        :for="'checkboxB-' + item.item_id"
                        class="label col2"
                        :key="'lbl' + item.item_id"
                        :style="getItemStyleObject(item.item_id)"
                        >{{ item.item_name }}</label
                      >
                    </template>
                  </div>
                </template>
              </div>
            </div>
            <div
              v-if="selectedSeasonId && selectedItemId && isMobileAny()"
              id="selectFlagButton"
              class="select-button"
              @click="hideTopFrame"
            >
              ほ場を選択
            </div>
          </div>
        </div>
      </transition>
    </div>
    <transition v-if="isShowSideFrame" name="fade" appear>
      <SearchResult>
        <ResultItem
          :paddyField="selectedPaddyField"
          :workHistories="workHistories"
          :isNotPaddyFieldItem="selectedItem ? isNotPaddyFieldItem : false"
          :flagSrc="isNotPaddyFieldItem ? '' : getFlagSrc()"
          :isReadOnly="isReadOnly"
          @clickWorkHistory="onClickWorkHistory"
          @zoomImage="onZoomImage"
        />
      </SearchResult>
    </transition>
    <div v-if="selectedWorkHistory" class="center-frame-container">
      <transition
        name="scale"
        @after-leave="
          selectedWorkHistory = null;
          selectedWorkHistoryImages = null;
        "
        appear
      >
        <div v-if="!isCenterFrameHidden" class="center-frame">
          <validation-observer ref="obs" v-slot="ObserverProps">
            <div class="title-area">
              <h3 v-if="isNotPaddyFieldItem">{{ selectedItem.item_name }}</h3>
              <h3 v-else>
                <span :class="getFlag()"></span>{{ selectedPaddyField.name }}
              </h3>
              <div class="btn-close" @click="hideCenterFrame"></div>
            </div>

            <div id="edit-area">
              <span v-if="!isCenterFrameEdit" class="active" @click="onEdit"
                >編集する</span
              >
            </div>

            <section class="section">
              <div class="container">
                <dl class="columns">
                  <template
                    v-for="itemDetail in selectedWorkHistory.item.item_details"
                  >
                    <dt :key="'label-' + itemDetail.item_detail_id">
                      {{ itemDetail.item_detail_name }}
                    </dt>
                    <template v-if="isCenterFrameEdit">
                      <dd
                        v-if="itemDetail.item_detail_type === 'date'"
                        :key="'date-input-' + itemDetail.item_detail_id"
                      >
                        <template v-if="itemDetail.display_flg === true">
                          <ValidationProvider
                            rules="required"
                            immediate
                            v-slot="ProviderProps"
                          >
                            <input
                              v-model="
                                workItemHistories[itemDetail.item_detail_id]
                              "
                              type="date"
                            />
                            <div class="validation-error">
                              {{ ProviderProps.errors[0] }}
                            </div>
                          </ValidationProvider>
                        </template>
                        <template v-else>
                          <input
                            v-model="
                              workItemHistories[itemDetail.item_detail_id]
                            "
                            type="date"
                          />
                        </template>
                      </dd>
                      <dd
                        v-else-if="itemDetail.item_detail_type === 'textarea'"
                        :key="'textarea-' + itemDetail.item_detail_id"
                      >
                        <ValidationProvider
                          rules="max:1000"
                          v-slot="ProviderProps"
                        >
                          <textarea
                            v-model="
                              workItemHistories[itemDetail.item_detail_id]
                            "
                          ></textarea>
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                      </dd>
                      <dd
                        v-else-if="itemDetail.item_detail_type === 'list'"
                        :key="'input-' + itemDetail.item_detail_id"
                      >
                        <ValidationProvider
                          class="input-with-unit"
                          rules="required|max:100"
                          immediate
                          v-slot="ProviderProps"
                        >
                          <input
                            v-model="
                              workItemHistories[itemDetail.item_detail_id]
                            "
                            type="text"
                          />
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                        <div v-if="users.length > 1" class="input-with-user">
                          <template v-for="(user, index) in users">
                            <label
                              class="label"
                              :key="'label-' + index"
                              @click="
                                onAddUser(user, itemDetail.item_detail_id)
                              "
                            >
                              {{ user.user_name }}</label
                            >
                          </template>
                        </div>
                      </dd>
                      <dd
                        v-else-if="itemDetail.item_detail_type === 'num'"
                        :key="'input-' + itemDetail.item_detail_id"
                      >
                        <ValidationProvider
                          class="input-with-unit"
                          rules="customDouble"
                          v-slot="ProviderProps"
                        >
                          <input
                            v-model="
                              workItemHistories[itemDetail.item_detail_id]
                            "
                            type="text"
                          />
                          <span
                            v-if="itemDetail.item_detail_unit"
                            class="unit"
                            >{{ itemDetail.item_detail_unit }}</span
                          >
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                        <!-- <template v-if="isItemDetailAuto(itemDetail)">
                            <div class="input-with-unit" style="padding:0 0 0 16px">
                              <span>
                                {{
                                  getItemDetailAutoValue(itemDetail.item_detail_id, selectedWorkHistory)
                                    | addComma
                                }}
                              </span>
                              <span class="unit">{{ getItemDetailAutoUnit(itemDetail) }}</span>
                            </div>
                        </template> -->
                      </dd>
                      <dd v-else :key="'input-' + itemDetail.item_detail_id">
                        <ValidationProvider
                          class="input-with-unit"
                          rules="max:100"
                          v-slot="ProviderProps"
                        >
                          <input
                            v-model="
                              workItemHistories[itemDetail.item_detail_id]
                            "
                            type="text"
                          />
                          <span
                            v-if="itemDetail.item_detail_unit"
                            class="unit"
                            >{{ itemDetail.item_detail_unit }}</span
                          >
                          <div class="validation-error">
                            {{ ProviderProps.errors[0] }}
                          </div>
                        </ValidationProvider>
                      </dd>
                    </template>
                    <template v-else>
                      <dd :key="'value-' + itemDetail.item_detail_id">
                        <div>
                          <span v-if="itemDetail.item_detail_type === 'num'">
                            {{
                              takeItemDetailValue(
                                itemDetail,
                                selectedWorkHistory
                              ) | addComma
                            }}</span
                          >
                          <span
                            v-else
                            :class="{
                              textarea:
                                itemDetail.item_detail_type === 'textarea',
                            }"
                          >
                            {{
                              takeItemDetailValue(
                                itemDetail,
                                selectedWorkHistory
                              )
                            }}
                          </span>
                          &ensp;
                          <span
                            v-if="
                              takeItemDetailValue(
                                itemDetail,
                                selectedWorkHistory
                              )
                            "
                            >{{ getItemDetailUnit(itemDetail) }}</span
                          >
                        </div>
                        <template v-if="isItemDetailAuto(itemDetail)">
                          <template
                            v-if="
                              takeItemDetailValue(
                                itemDetail,
                                selectedWorkHistory
                              )
                            "
                          >
                            <div>
                              <span>
                                {{
                                  getItemDetailAutoValue(
                                    itemDetail.item_detail_id,
                                    selectedWorkHistory
                                  ) | addComma
                                }}</span
                              >
                              &ensp;
                              <span>{{
                                getItemDetailAutoUnit(itemDetail)
                              }}</span>
                            </div>
                          </template>
                        </template>
                      </dd>
                    </template>
                  </template>
                  <template>
                    <dt>
                      <div id="upload-area">
                        <label v-if="isCenterFrameEdit" class="active">
                          <input
                            type="file"
                            ref="preview"
                            accept="image/png, image/jpeg"
                            @change="readFile"
                            multiple
                          />画像アップロード
                        </label>
                      </div>
                    </dt>
                    <dd>
                      <div class="upload-area-view">
                        <template v-if="isCenterFrameEdit">
                          <div v-for="(row, index) in workImages" :key="index">
                            <span class="active" @click="deletePreview(index)">
                            </span>
                            <template v-if="row.data">
                              <img :src="row.data" />
                            </template>
                            <template v-else>
                              <img :src="row.url" />
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-for="(row, index) in selectedWorkHistoryImages"
                            :key="index"
                          >
                            <template v-if="row.data">
                              <img :src="row.data" />
                            </template>
                            <template v-else>
                              <img :src="row.url" />
                            </template>
                          </div>
                        </template>
                      </div>
                    </dd>
                  </template>
                </dl>
              </div>
            </section>

            <div class="button-area" v-if="isCenterFrameEdit">
              <div class="left-box" />
              <div class="center-box">
                <span
                  class="btn btn-submit"
                  :class="{
                    active: anyItemDetailInput,
                    disable: ObserverProps.invalid,
                  }"
                  @click="onSubmit"
                  >保存</span
                >
                <span class="btn btn-cancel" @click="onCancel">キャンセル</span>
              </div>
              <div class="right-box">
                <span
                  class="text"
                  :class="{ active: anyItemDetailInput }"
                  @click="onDelete"
                  >削除</span
                >
              </div>
            </div>
          </validation-observer>
        </div>
      </transition>
    </div>
    <div v-if="selectedImageUrl" class="image-frame-container">
      <transition name="scale" @after-leave="selectedImageUrl = null" appear>
        <div class="image-frame">
          <div class="image-title-area">
            <div />
            <div class="btn-close" @click="hideImageFrame"></div>
          </div>
          <section class="section">
            <div class="container">
              <img :src="selectedImageUrl" />
            </div>
          </section>
          <div class="image-footer-area"></div>
        </div>
      </transition>
    </div>
    <transition v-if="isShowAreaFrame" name="fade" appear>
      <div class="area-frame-container">
        <div class="area-frame">
          <div class="area-frame-header">
            <h4>ほ場面積</h4>
            <div class="btn-close" @click="hideAreaFrame"></div>
          </div>
          <div class="area-frame-content">
            <!-- <ul>
              <template v-for="(row, index) in areaInfos">
                <li :key="index">{{ row.brand_name }} {{ row.area }} (a)</li>
              </template>
            </ul> -->
            <div style="margin:10px">
              <table>
                <template v-for="(row, index) in areaInfos">
                  <tr :key="index">
                    <td>{{ row.brand_name }}</td>
                    <td class="unit">{{ row.count }}枚</td>
                    <td class="value">{{ row.area | addComma }} (a)</td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
          <div class="area-frame-footer"></div>
        </div>
      </div>
    </transition>
    <transition v-if="isShowSearchFrame" name="scale" appear>
      <div class="center-frame-container search-frame">
        <div class="center-frame">
          <div class="center-frame-header">
            <h3 class="title-icon-search"><div>作業の検索</div></h3>
            <div class="btn-close" @click="isShowSearchFrame = false"></div>
          </div>
          <div class="center-frame-content">
            <validation-observer ref="obs" v-slot="ObserverProps">
              <div class="section">
                <div class="container">
                  <ValidationProvider rules="required" immediate>
                    <input v-model="searchCriteria" type="text" />
                  </ValidationProvider>
                </div>
              </div>
              <div class="button-area">
                <div class="left-box" />
                <div class="center-box" />
                <div class="right-box">
                  <span
                    class="btn btn-submit"
                    :class="{
                      disable: ObserverProps.invalid,
                    }"
                    @click="onClickSearchWorkHistories"
                    >検索</span
                  >
                </div>
              </div>
            </validation-observer>
          </div>
          <div class="center-frame-footer"></div>
        </div>
      </div>
    </transition>
    <transition
      v-if="
        searchResult.listPaddy.length > 0 ||
          searchResult.globalWorkHistories.length > 0
      "
      name="fade"
      appear=""
    >
      <SearchResult>
        <template v-for="listPaddyItem in searchResult.listPaddy">
          <ResultItem
            :key="listPaddyItem.paddy_field_id"
            :paddyField="listPaddyItem"
            :workHistories="listPaddyItem.workHistories"
            :isNotPaddyFieldItem="false"
            :flagSrc="getFlagSrc(listPaddyItem)"
            :isReadOnly="isReadOnly"
            :isSearchDialog="true"
            @zoomImage="onZoomImage"
            @clickHeader="onClickSearchResultHeader"
          />
        </template>
        <template v-if="searchResult.globalWorkHistories.length > 0">
          <ResultItem
            :workHistories="searchResult.globalWorkHistories"
            :isNotPaddyFieldItem="true"
            :isReadOnly="isReadOnly"
            :isSearchDialog="true"
            @zoomImage="onZoomImage"
          />
        </template>
      </SearchResult>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoogleMaps from "@/mixins/googlemaps.js";
import Loader from "@/mixins/loader";
import Dialog from "@/mixins/dialog";
import isMobile from "@/mixins/ismobile";
import SearchResult from "@/components/work-history/SearchResult";
import ResultItem from "@/components/work-history/ResultItem";
import { Storage } from "aws-amplify";
import Compression from "@/mixins/compression";

const CENTER_FRAME_STATUS = { HIDDEN: 0, REFERENCE: 1, EDIT: 2 };
const FILTER_FRAME_STATUS = { HIDDEN: 0, WORK: 1, LOCATION: 2 };

export default {
  mixins: [GoogleMaps, Loader, Dialog, isMobile, Compression],
  components: { SearchResult, ResultItem },

  data() {
    return {
      initialized: false,
      markers: [],
      locationMarkers: [],
      seasons: [],
      users: [],
      // 作業履歴のサマリ
      storedWorkHistorySummaries: null,
      // 作業項目選択画面を表示することを示すフラグ
      showTopFrame: false,
      // 作業実績一覧画面を表示することを示すフラグ
      showWorkHistory: false,
      // 作業実績詳細・編集画面の表示状態
      centerFrameStatus: CENTER_FRAME_STATUS.HIDDEN,
      // 作業項目選択を折りたたむことを示すフラグ
      collapseInputFrame: true,
      // 選択した作業大分類のID
      selectedSeasonId: null,
      // 選択した作業項目のID
      selectedItemId: null,
      // 選択した田圃
      selectedPaddyField: null,
      // 選択した田圃の作業実績
      workHistories: null,
      // 選択した作業実績
      selectedWorkHistory: null,
      // 選択した作業実績の画像パス
      selectedWorkHistoryImages: null,
      // 作業項目内容入力フォームにバインドするデータ
      workItemHistories: {}, // TODO workItemsに変更
      workItemAutoHistories: {},
      // 作業項目内容入力フォームにバインドするデータ(画像)
      workImages: {},
      // 選択した画像
      selectedImageUrl: null,
      // 読み取り専用
      isReadOnly: true,
      // Mapに表示するLine情報
      mapPolylines: [],
      // フィルタ
      filterFrameStatus: FILTER_FRAME_STATUS.HIDDEN,
      // 位置情報フィルタ条件
      selectedFilterLoation: {
        users: [],
        locationDate: null,
        dateMin: null,
        dateMax: null,
        startTime: null,
        endTime: null,
      },
      // 時間
      filterTimes: [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",
        "24:00",
      ],
      // 位置情報
      locationHistories: null,
      // 位置情報フィルタ検索条件
      filterLocationCondition: {
        from: null,
        to: null,
        users: [],
      },
      areaInfos: [],
      isShowAreaFrame: false,
      isShowSearchFrame: false,
      searchCriteria: "",
      searchResult: {
        listPaddy: [],
        globalWorkHistories: [],
        centeredMarker: null,
      },
    };
  },

  computed: {
    selectedSeason() {
      return this.seasons.find((e) => e.season_id === this.selectedSeasonId);
    },

    selectedItem() {
      if (this.selectedSeasonId) {
        return this.selectedSeason.items.find(
          (e) => e.item_id === this.selectedItemId
        );
      } else {
        return null;
      }
    },

    anyItemDetailInput() {
      let b = false;
      for (const k in this.workItemHistories) {
        if (this.workItemHistories.hasOwnProperty(k)) {
          const element = this.workItemHistories[k];
          if (element) {
            b = true;
            break;
          }
        }
      }
      return b;
    },

    isNotPaddyFieldItem() {
      return this.selectedItem && this.selectedItem.is_not_paddy_field_item;
    },

    isShowSideFrame() {
      if (this.isNotPaddyFieldItem && !this.selectedPaddyField) {
        // 田圃外作業を選択済みで田圃が未選択の場合
        // isShowWorkHistoryだけで判断
        return this.showWorkHistory;
      } else {
        return this.selectedPaddyField && this.showWorkHistory;
      }
    },

    isCenterFrameHidden() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.HIDDEN;
    },

    isCenterFrameEdit() {
      return this.centerFrameStatus === CENTER_FRAME_STATUS.EDIT;
    },

    isFilterFrameHidden() {
      return this.filterFrameStatus === FILTER_FRAME_STATUS.HIDDEN;
    },

    isFilterFrameWork() {
      return this.filterFrameStatus === FILTER_FRAME_STATUS.WORK;
    },

    isFilterFrameLocation() {
      return this.filterFrameStatus === FILTER_FRAME_STATUS.LOCATION;
    },
  },

  filters: {
    addComma(val) {
      if (!val) {
        return val;
      }
      // 整数部のみカンマをつける
      const vals = val.toString().split(".");
      let ret = vals[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (vals.length > 1) {
        ret += "." + vals[1];
      }
      return ret;
    },

    nl2br(str) {
      return str.replace(/\r?\n/g, "<br>");
    },
  },

  async mounted() {
    this.loading(async () => {
      this.$emit("showMap");
      if (this.isMobileAny()) {
        this.$emit("hideMenu");
      }
      try {
        const acinfo = await this.showAccount(await this.showAccountID());
        this.isReadOnly =
          this.isAccountExpired(acinfo) || this.isPastManagement();
      } catch (error) {
        console.log(error);
      }
      try {
        var retSeasons = await this.retrieveSeasons();
        retSeasons.forEach((element) => {
          if (!element.color) {
            element.color = "#1a82b7";
          }
        });
        this.seasons = retSeasons;

        // マーカー初期表示
        await this.loadMarkers();
        this.setSelectListener();

        // 位置情報マーカー表示
        await this.listUsers();

        this.initFilterLocationCondition();

        await this.loadLocationMarkers();

        // 面積
        this.areaInfos = await this.retrievePaddyFieldAreas();

        // 初期化終了フラグ
        this.initialized = true;
        // モバイル表示の場合、初期表示時は作業項目選択エリアは表示しない
        if (this.isMobileAny()) {
          this.showTopFrame = false;
          this.showWorkHistory = false;
        } else {
          this.showTopFrame = true;
          this.showWorkHistory = true;
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  },

  destroyed() {
    this.clearMarkers();
    this.clearLocationMarkers();
  },

  methods: {
    ...mapActions([
      "retrieveSeasons",
      "retrievePaddyFields",
      "retrievePaddyFieldHistories",
      "searchWorkHistories",
      "showWorkHistories",
      "retrieveGlobalWorkHistories",
      "updateWorkHistory",
      "updateGlobalWorkHistory",
      "deleteWorkHistory",
      "deleteGlobalWorkHistory",
      "showAccount",
      "showAccountID",
      "retrieveLocationHistories",
      "showUsersAll",
      "retrievePaddyFieldAreas",
    ]),
    ...mapGetters(["getPaddyFields", "getManagements", "isPastManagement"]),

    async loadMarkers() {
      // 最新の田圃の位置情報を取得
      await this.retrievePaddyFields();
      // 作業履歴のサマリを取得
      this.storedWorkHistorySummaries = await this.retrievePaddyFieldHistories();

      // 現在マップに残っているマーカーをクリア
      this.clearMarkers();
      // マーカー表示
      this.putMarkers();
    },

    async loadLocationMarkers() {
      // 現在マップに残っているマーカーをクリア
      this.clearLocationMarkers();

      await this.searchLocationHistories();

      // マーカー表示
      this.putLocationMarkers();
    },

    async searchLocationHistories() {
      // 位置情報履歴取得
      this.locationHistories = await this.retrieveLocationHistories({
        from: this.filterLocationCondition.from,
        to: this.filterLocationCondition.to,
      });
    },

    async listUsers() {
      this.users = [];
      try {
        const Users = await this.showUsersAll();
        Users.forEach((user) => {
          let name = "";
          if (user.Attributes) {
            user.Attributes.forEach((attr) => {
              if (attr.Name === "custom:display_name") {
                name = attr.Value;
              }
            });
          }
          if (!user.color) {
            this.users.push({
              user_name: name,
              color: "#E57373",
              user_id: user.user_id,
            });
          } else {
            this.users.push({
              user_name: name,
              color: user.color,
              user_id: user.user_id,
            });
          }
        });
      } catch (e) {
        console.error(e);
      }
    },

    putMarkers() {
      const { Marker } = this.google.maps;
      let paddyFields = this.getPaddyFields();
      paddyFields.forEach((paddyField) => {
        const lat = parseFloat(paddyField.map_pos.split(",")[0]);
        const lng = parseFloat(paddyField.map_pos.split(",")[1]);

        const marker = new Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
        });
        marker.set("paddyField", paddyField);
        marker.setIcon(this.buildMarkerIconProps(marker));
        this.setInfoWindow(marker, paddyField);
        this.markers.push(marker);
      });
    },
    putLocationMarkers() {
      const { Marker } = this.google.maps;

      // ユーザの数分ループ
      this.filterLocationCondition.users.forEach((user_id) => {
        const hist = this.locationHistories[user_id];
        const user = this.users.find((el) => el.user_id === user_id);
        const color = user.color;
        if (hist && hist.length > 0) {
          // ライン
          let lines = [];
          hist.forEach((item) => {
            lines.push({
              lat: item.lat,
              lng: item.lon,
            });
          });
          var flightPath = new this.google.maps.Polyline({
            path: lines,
            strokeColor: color,
            strokeOpacity: 1,
            strokeWeight: 4,
          });
          flightPath.setMap(this.map);
          this.mapPolylines.push(flightPath);

          // 開始、終了地点
          // 1点のみの場合、終端のみ
          if (hist.length > 1) {
            // スタート地点
            const startMarker = new Marker({
              position: { lat: hist[0]["lat"], lng: hist[0]["lon"] },
              map: this.map,
            });
            startMarker.setIcon({
              fillColor: "#FFFFFF", //画像の色（緑色系）
              fillOpacity: 1.0, //画像の透明度
              path: this.google.maps.SymbolPath.CIRCLE, //下向きの矢印画像を指定
              scale: 6, //画像の倍率スケール（10倍）
              strokeColor: color, //枠の色（深緑系）
              strokeWeight: 3, //枠の太さ
            });
            var endDt = new Date(hist[0]["location_time"]);
            this.setLocationInfoWindow(startMarker, {
              time:
                endDt
                  .getHours()
                  .toString()
                  .padStart(2, "0") +
                ":" +
                endDt
                  .getMinutes()
                  .toString()
                  .padStart(2, "0"),
              user_name: user["user_name"],
            });
            this.locationMarkers.push(startMarker);
          }
          // 終端
          const endMarker = new Marker({
            position: {
              lat: hist[hist.length - 1]["lat"],
              lng: hist[hist.length - 1]["lon"],
            },
            map: this.map,
          });
          endMarker.setIcon({
            fillColor: color, //画像の色（緑色系）
            fillOpacity: 1.0, //画像の透明度
            path: this.google.maps.SymbolPath.CIRCLE, //下向きの矢印画像を指定
            scale: 6, //画像の倍率スケール（10倍）
            strokeColor: color, //枠の色（深緑系）
            strokeWeight: 1, //枠の太さ
          });
          var startDt = new Date(hist[hist.length - 1]["location_time"]);
          this.setLocationInfoWindow(endMarker, {
            time:
              startDt
                .getHours()
                .toString()
                .padStart(2, "0") +
              ":" +
              startDt
                .getMinutes()
                .toString()
                .padStart(2, "0"),
            user_name: user["user_name"],
          });
          this.locationMarkers.push(endMarker);
        }
      });
    },

    setInfoWindow(marker, paddyField) {
      var message = [];
      if (paddyField.name) {
        message.push(paddyField.name);
      }
      if (paddyField.area) {
        message.push(paddyField.area + "&nbsp(a)");
      }
      // 品種はマスタの値を表示
      if (paddyField.brand) {
        message.push(paddyField.brand);
      }
      // 耕作者
      if (paddyField.kousakusha) {
        message.push(paddyField.kousakusha);
      }
      // メモ
      if (paddyField.remarks) {
        message.push(paddyField.remarks);
      }

      var infowin = new this.google.maps.InfoWindow({
        content: message.join("<br>"),
      });

      // mouseoverイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseover", function() {
        infowin.open(marker.getMap(), marker);
      });

      // mouseoutイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseout", function() {
        infowin.close();
      });
    },
    setLocationInfoWindow(marker, locationInfo) {
      var message = [];
      message.push(locationInfo.time);
      message.push(locationInfo.user_name);
      var infowin = new this.google.maps.InfoWindow({
        content: message.join("<br>"),
      });

      // mouseoverイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseover", function() {
        infowin.open(marker.getMap(), marker);
      });

      // mouseoutイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseout", function() {
        infowin.close();
      });
    },

    onSelectSeason() {
      if (this.selectedItemId) {
        // 前に選んでいた作業分類の中の作業項目を選択済みだった場合はクリアするが
        // それがほ場外作業だった場合は作業実績をクリアしておく

        // this.selectedSeasonIdに依存したcomputedの関数は当てにできないので
        // マスタデータから直接作業項目マスタを検索する。
        const prevItem = this.seasons
          .flatMap((season) => season.items)
          .find((item) => item.item_id === this.selectedItemId);
        if (prevItem.is_not_paddy_field_item) {
          this.workHistories = null;
        }
        this.selectedItemId = null;
      }

      this.filterMarkers();
    },

    onChangeItem() {
      this.filterMarkers();
      this.filterFrameStatus = FILTER_FRAME_STATUS.HIDDEN;
      if (this.isNotPaddyFieldItem) {
        // 田圃外作業を選択した場合
        this.loading(async () => {
          this.clearSearchDialog();

          try {
            // 作業履歴を取得
            const workHistoryResponse = await this.retrieveGlobalWorkHistories({
              id: this.selectedItemId,
            });

            // データを加工して画面表示
            this.workHistories = await this.organizeWorkHistories(
              workHistoryResponse.data,
              this.selectedItem
            );
          } catch (error) {
            alert(error);
            throw error;
          }

          // 田圃選択を解除
          this.clearMarkerSelection();
          this.selectedPaddyField = null;
        });
      }
    },

    onClickItem(ev) {
      if (
        ev.currentTarget.checked &&
        ev.currentTarget.value === this.selectedItemId
      ) {
        // 選択中の作業項目を再度クリックしたら選択を外す
        this.selectedItemId = null;
        this.filterMarkers();
      }
    },

    async onClickWorkHistory(workHistory) {
      this.selectedWorkHistory = workHistory;
      this.selectedWorkHistoryImages = [];
      if (workHistory.image_paths) {
        for (const path of workHistory.image_paths) {
          const url = await Storage.get(path);
          const item = {
            path: path,
            url: url,
          };
          this.selectedWorkHistoryImages.push(item);
        }
      }
      this.centerFrameStatus = CENTER_FRAME_STATUS.REFERENCE;
    },

    onEdit() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.EDIT;

      // フォームは作業項目マスタ次第で動的に変わる。
      // フォームの入力値をバインドするオブジェクトworkItemHistoriesは普通に利用したのでは
      // リアクティブにならない事があるので、$set()を使って毎回オブジェクト内のプロパティを初期化する。
      this.workItemHistories = {};
      this.workImages = [];
      this.workItemAutoHistories = {};
      this.selectedWorkHistory.item.item_details.forEach((itemDetail) => {
        const workItem = this.selectedWorkHistory.work_items_merged.find(
          (e) => e.item_detail_id === itemDetail.item_detail_id
        );
        let val = "";
        if (workItem) {
          val = workItem.value;
        }
        let valAuto = "";
        if (this.selectedWorkHistory.work_items_auto) {
          const workItemAuto = this.selectedWorkHistory.work_items_auto[
            itemDetail.item_detail_id
          ];
          if (workItemAuto) {
            valAuto = workItemAuto;
          }
        }
        this.$set(this.workItemHistories, itemDetail.item_detail_id, val);
        this.$set(
          this.workItemAutoHistories,
          itemDetail.item_detail_id,
          valAuto
        );
      });
      for (const item of this.selectedWorkHistoryImages) {
        this.workImages.push(item);
      }
    },

    hideCenterFrame() {
      this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
      this.workItemHistories = {};
    },
    hideFilterFrame() {
      this.filterFrameStatus = FILTER_FRAME_STATUS.HIDDEN;
    },
    hideTopFrame() {
      this.showTopFrame = false;
    },
    hideAreaFrame() {
      this.isShowAreaFrame = false;
    },

    onChangeLocationFilterStartTime() {
      const sIdx = this.filterTimes.indexOf(
        this.selectedFilterLoation.startTime
      );
      const eIdx = this.filterTimes.indexOf(this.selectedFilterLoation.endTime);
      if (sIdx >= eIdx) {
        this.selectedFilterLoation.endTime = this.filterTimes[sIdx + 1];
      }
    },
    onChangeLocationFilterEndTime() {
      const sIdx = this.filterTimes.indexOf(
        this.selectedFilterLoation.startTime
      );
      const eIdx = this.filterTimes.indexOf(this.selectedFilterLoation.endTime);
      if (sIdx >= eIdx) {
        this.selectedFilterLoation.startTime = this.filterTimes[eIdx - 1];
      }
    },

    async onSubmit() {
      this.loading(async () => {
        try {
          // 値がブランクの項目は削除
          for (const k in this.workItemHistories) {
            if (this.workItemHistories.hasOwnProperty(k)) {
              const val = this.workItemHistories[k];
              if (!val) {
                delete this.workItemHistories[k];
              }
            }
          }

          // 画像アップロード
          const nowDatetime = this.formatDatetime(new Date());
          const mngDatas = this.getManagements();
          const mngId = mngDatas[0]["management_id"];
          for (let i = 0; i < this.workImages.length; i++) {
            // 画像が追加されていたらアップロード
            if (this.workImages[i].file) {
              let ext = this.workImages[i].fileName.substr(
                this.workImages[i].fileName.lastIndexOf(".")
              );
              ext = ext.toLowerCase();
              if ([".jpg",".jpeg",".jpe",".jif",".jfif",".jfi"].includes(ext)) {
                ext = ".jpg";
              }
              const s3FileName =
                mngId + "/image/" + nowDatetime + "/" + (i + 1) + ext;
              await Storage.put(s3FileName, this.workImages[i].file, {
                level: "public",
                contentType: this.workImages[i].type,
              });
              this.workImages[i].path = s3FileName;
            }
          }
          const imagePaths = [];
          for (const item of this.workImages) {
            imagePaths.push(item.path);
          }

          if (this.isNotPaddyFieldItem) {
            // 田圃外作業の更新
            await this.updateGlobalWorkHistory({
              workHistory: this.selectedWorkHistory,
              workItems: this.workItemHistories,
              imagePaths: imagePaths,
            });
          } else {
            // 更新
            await this.updateWorkHistory({
              workHistory: this.selectedWorkHistory,
              workItems: this.workItemHistories,
              imagePaths: imagePaths,
            });
          }

          // 内部データクリア
          this.selectedPaddyField = null;
          this.selectedWorkHistory = null;
          this.selectedWorkHistoryImages = null;
          this.workItemHistories = {};
          this.workImages = null;
          this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
          if (this.isMobileAny()) {
            this.showWorkHistory = false;
          }
          if (this.isNotPaddyFieldItem) {
            // 田圃外作業を選択済みの場合はonchangeイベントハンドラを実行
            this.onChangeItem();
          } else {
            this.workHistories = null;
          }

          // マーカーをリロード
          await this.loadMarkers();
          this.setSelectListener();
        } catch (error) {
          alert("通信エラー");
          console.log(error);
          throw error;
        }
      });
    },
    async onDelete() {
      this.showConfirm("削除しますか？", async () => {
        this.loading(async () => {
          try {
            if (this.isNotPaddyFieldItem) {
              // 田圃外作業の削除
              await this.deleteGlobalWorkHistory({
                id: this.selectedWorkHistory.work_history_id,
              });
            } else {
              // 削除
              await this.deleteWorkHistory({
                id: this.selectedWorkHistory.work_history_id,
              });
            }

            // 内部データクリア
            this.selectedPaddyField = null;
            this.selectedWorkHistory = null;
            this.selectedWorkHistoryImages = null;
            this.workItemHistories = {};
            this.workImages = null;
            this.centerFrameStatus = CENTER_FRAME_STATUS.HIDDEN;
            if (this.isMobileAny()) {
              this.showWorkHistory = false;
            }
            if (this.isNotPaddyFieldItem) {
              // 田圃外作業を選択済みの場合はonchangeイベントハンドラを実行
              this.onChangeItem();
            } else {
              this.workHistories = null;
            }

            // マーカーをリロード
            await this.loadMarkers();
            this.setSelectListener();
          } catch (error) {
            alert("通信エラー");
            console.log(error);
            throw error;
          }
        });
      });
    },

    setSelectListener() {
      this.markers.forEach((marker) => {
        marker.addListener("click", async () => {
          await this.loading(async () => {
            this.clearSearchDialog();

            const clickedPaddyField = marker.get("paddyField");

            // マーカーの選択状況を反転
            marker.setIcon(this.buildMarkerIconProps(marker, true));

            // 選択済みのマーカーをクリックしたのか
            let hasSelected = this.selectedPaddyField === clickedPaddyField;

            if (hasSelected) {
              // 選択解除
              this.selectedPaddyField = null;
            } else {
              // 元々選択済みだった方のマーカーを選択反転する
              this.clearMarkerSelection();

              this.selectedPaddyField = clickedPaddyField;
            }

            // 選択済み作業項目が田圃外作業の場合は作業項目の選択を解除
            if (this.isNotPaddyFieldItem) {
              this.clearSelectedItem();
              this.collapseInputFrame = true;
            }

            // いま選択状態のマーカーがある場合はデータ取得
            if (this.selectedPaddyField) {
              try {
                // 作業履歴を取得
                const workHistoryResponse = await this.showWorkHistories(
                  clickedPaddyField.paddy_field_id
                );

                // データを加工して画面表示
                this.workHistories = await this.organizeWorkHistories(
                  workHistoryResponse.data
                );
              } catch (error) {
                alert(error);
                throw error;
              }
            } else {
              this.workHistories = [];
            }
          });
        });
      });
    },

    clearMarkerSelection() {
      if (this.selectedPaddyField) {
        const nowSelected = this.markers.find(
          (m) => m.get("paddyField") === this.selectedPaddyField
        );
        nowSelected.setIcon(this.buildMarkerIconProps(nowSelected, true));
      }
    },

    buildMarkerIconProps(marker, toggleSelection = false) {
      if (!marker.get("paddyField")) {
        return;
      }
      // アイコンファイル名の組み立て
      let flagType = marker.get("paddyField").pin_type
        ? marker.get("paddyField").pin_type
        : "ricelog_pinicon_040";
      let iconName = "";
      if (this.selectedItemId) {
        // 選択した作業項目をすでに登録済みのマーカーか
        let stored = this.isSelectedItemStored(marker.get("paddyField"));
        if (stored) {
          // 登録済みの場合は末尾を1にする
          iconName += flagType.slice(0, -1) + "1";
        } else {
          iconName += flagType;
        }
      } else {
        iconName += flagType;
      }

      const markerPaddyFieldId = marker.get("paddyField").paddy_field_id;
      // ほ場マップ上でクリックしたマーカーのほ場ID
      let selectedPaddyFieldId = null;
      if (this.selectedPaddyField) {
        selectedPaddyFieldId = this.selectedPaddyField.paddy_field_id;
      }
      // 作業の検索結果一覧でヘッダクリックしたほ場のほ場ID
      let centeredPaddyFieldId = null;
      if (this.searchResult.centeredMarker) {
        centeredPaddyFieldId = this.searchResult.centeredMarker.get(
          "paddyField"
        ).paddy_field_id;
      }
      // 上の２つのほ場IDどちらかと一致するほ場IDのマーカーなら現在選択済み状態であるとみなす
      let selected =
        markerPaddyFieldId === selectedPaddyFieldId ||
        markerPaddyFieldId === centeredPaddyFieldId;
      if (toggleSelection) {
        // 選択を反転
        selected = !selected;
      }
      if (selected) {
        var type = parseInt(iconName.slice(-1), 10) + 2;
        iconName = iconName.slice(0, -1) + type;
      }

      let iconProps = { url: require("@/assets/pin/" + iconName + ".png") };
      if (selected) {
        iconProps = Object.assign(iconProps, {
          scaledSize: { width: 24, height: 42 },
          anchor: { x: 12, y: 42 },
        });
      } else {
        iconProps = Object.assign(iconProps, {
          scaledSize: { width: 24, height: 42 },
          anchor: { x: 12, y: 42 },
        });
      }
      return iconProps;
    },

    isSelectedItemStored(paddyField) {
      let stored = false;
      if (this.selectedItemId) {
        // 作業項目は選択済み
        if (
          this.storedWorkHistorySummaries &&
          this.storedWorkHistorySummaries.data
        ) {
          // 全田圃の作業履歴は取得済み
          const workHistory = this.storedWorkHistorySummaries.data.find(
            (e) =>
              e.paddy_field_id === paddyField.paddy_field_id &&
              e.item_id === this.selectedItemId
          );
          if (workHistory) {
            stored = true;
          }
        }
      }
      return stored;
    },

    clearMarkers() {
      this.markers.forEach((e) => {
        // Mapとの紐付けを解除しイベントリスナーを削除
        e.setMap(null);
        this.google.maps.event.clearInstanceListeners(e);
      });
      this.markers = [];
    },

    clearLocationMarkers() {
      this.locationMarkers.forEach((e) => {
        // Mapとの紐付けを解除しイベントリスナーを削除
        e.setMap(null);
        this.google.maps.event.clearInstanceListeners(e);
      });
      this.locationMarkers = [];
      this.mapPolylines.forEach((element) => {
        element.setMap(null);
        element = null;
      });
      this.mapPolylines = [];
    },

    renderExecDate(workHistory) {
      let date = "";
      if (workHistory.work_items_merged) {
        const execDate = workHistory.work_items_merged.find(
          (e) => e.display_flg === true
        );
        if (execDate) {
          return execDate.value;
        }
      }
      return date;
    },

    takeItemDetailValue(itemDetail, workHistory) {
      // 作業履歴の詳細の中から引数のitemDetailに対応するものを検索
      const workItem = workHistory.work_items_merged.find(
        (e) => e.item_detail_id === itemDetail.item_detail_id
      );

      if (workItem) {
        return workItem.value;
      } else {
        return "";
      }
    },

    takeItemDetailAutoValue(itemDetail, workHistory) {
      // 作業履歴の詳細の中から引数のitemDetailに対応するものを検索
      const workItem = workHistory.work_items_auto.find(
        (e) => e.item_detail_id === itemDetail.item_detail_id
      );

      if (workItem) {
        return workItem.value;
      } else {
        return "";
      }
    },

    filterMarkers() {
      this.markers.forEach((marker) => {
        // 選択した作業項目の登録状況でマーカーの色を変える
        marker.setIcon(this.buildMarkerIconProps(marker));
      });
    },

    onCancel() {
      // 田圃詳細を表示する
      this.centerFrameStatus = CENTER_FRAME_STATUS.REFERENCE;
    },

    onStartEditMobile() {
      this.showTopFrame = true;
    },

    clearSelectedItem() {
      this.selectedItemId = null;
      this.filterMarkers();
    },

    getFlag(paddyField) {
      const targetPaddyField = paddyField
        ? paddyField
        : this.selectedPaddyField;
      if (targetPaddyField.pin_type) {
        return targetPaddyField.pin_type;
      } else {
        return "ricelog_pinicon_040";
      }
    },
    getFlagSrc(paddyField) {
      return require("@/assets/pin/" + this.getFlag(paddyField) + ".png");
    },

    async onZoomImage(path) {
      this.selectedImageUrl = await Storage.get(path);
    },
    hideImageFrame() {
      this.selectedImageUrl = null;
    },
    /////////////////////////////////
    // WorkHistoryShowと同じ処理
    ////////////////////////////////
    async readFile() {
      this.loading(async () => {
        const files = this.$refs.preview.files;
        for (const file of files) {
          try {
            const compFile = await Compression.getCompressImageFileAsync(file);
            const picture = await this.getBase64(compFile);
            this.workImages.push({
              fileName: file.name,
              size: compFile.size,
              type: file.type,
              data: picture,
              file: compFile,
            });
          } catch (error) {
            console.log(error);
          }
        }
        this.$refs.preview.value = "";
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    deletePreview(index) {
      this.workImages.splice(index, 1);
    },
    formatDatetime(src, format = "YYYYMMDDHHmmssSSS") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      dest = dest.replace(/SSS/, ("0" + date.getMilliseconds()).slice(-3));
      return dest;
    },

    isAccountExpired(acinfo) {
      if (acinfo) {
        if (acinfo.admin === 1) {
          return false;
        }
        if (acinfo.display_mode) {
          if (
            acinfo.display_mode.type === 1 ||
            acinfo.display_mode.type === 3
          ) {
            return false;
          }
        }
      }
      return true;
    },

    onClickFilterWork() {
      this.filterFrameStatus = FILTER_FRAME_STATUS.WORK;
    },
    onClickFilterLocation() {
      var startDt = new Date(this.filterLocationCondition.from);
      var endDt = new Date(this.filterLocationCondition.to);

      // to設定(24:00は翌日の0:00時になるので、開始時間を年月日で使用する)
      var year = startDt.getFullYear().toString();
      var month = (startDt.getMonth() + 1).toString().padStart(2, "0");
      var day = startDt
        .getDate()
        .toString()
        .padStart(2, "0");
      this.selectedFilterLoation.locationDate = year + "-" + month + "-" + day;

      // 24:00は翌日の0:00時になるので、0時の場合、24時とする
      var hour = endDt.getHours();
      if (hour > 0) {
        this.selectedFilterLoation.endTime = this.filterTimes[hour];
      } else {
        this.selectedFilterLoation.endTime = this.filterTimes[
          this.filterTimes.length - 1
        ];
      }
      // from設定
      this.selectedFilterLoation.startTime = this.filterTimes[
        startDt.getHours()
      ];
      // user設定
      this.selectedFilterLoation.users = this.filterLocationCondition.users;

      this.filterFrameStatus = FILTER_FRAME_STATUS.LOCATION;
    },
    async onClickSearchLocation() {
      // 検索条件設定
      this.filterLocationCondition = {
        from:
          this.selectedFilterLoation.locationDate +
          "T" +
          this.selectedFilterLoation.startTime +
          ":00+0900",
        to:
          this.selectedFilterLoation.locationDate +
          "T" +
          this.selectedFilterLoation.endTime +
          ":00+0900",
        users: this.selectedFilterLoation.users,
      };
      this.filterFrameStatus = FILTER_FRAME_STATUS.HIDDEN;
      this.loading(async () => {
        try {
          await this.loadLocationMarkers();
        } catch (error) {
          console.log(error);
          throw error;
        }
      });
    },

    initFilterLocationCondition() {
      // 日付設定
      var dt = new Date();
      var year = dt.getFullYear().toString();
      var month = (dt.getMonth() + 1).toString().padStart(2, "0");
      var day = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      var hour = dt.getHours();
      this.selectedFilterLoation.dateMax = year + "-" + month + "-" + day;
      this.selectedFilterLoation.locationDate = year + "-" + month + "-" + day;
      this.selectedFilterLoation.endTime = this.filterTimes[hour + 1];
      // 7日分
      dt.setDate(dt.getDate() - 6);
      var startYear = dt.getFullYear().toString();
      var startMonth = (dt.getMonth() + 1).toString().padStart(2, "0");
      var startDay = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      this.selectedFilterLoation.dateMin =
        startYear + "-" + startMonth + "-" + startDay;

      var idx = hour - 2;
      if (idx < 0) {
        idx = 0;
      }
      this.selectedFilterLoation.startTime = this.filterTimes[idx];
      this.users.forEach((user) => {
        this.selectedFilterLoation.users.push(user.user_id);
      });

      this.filterLocationCondition = {
        from:
          this.selectedFilterLoation.locationDate +
          "T" +
          this.selectedFilterLoation.startTime +
          ":00+0900",
        to:
          this.selectedFilterLoation.locationDate +
          "T" +
          this.selectedFilterLoation.endTime +
          ":00+0900",
        users: this.selectedFilterLoation.users,
      };
    },
    onAddUser(user, detailId) {
      let _name = "";
      if (
        this.workItemHistories[detailId] &&
        this.workItemHistories[detailId].length > 0
      ) {
        _name = this.workItemHistories[detailId] + "、";
      }
      _name = _name + user.user_name;
      this.workItemHistories[detailId] = _name;
    },

    getSeasonStyleObject(id) {
      const season = this.seasons.find((m) => m.season_id === id);
      if (id === this.selectedSeasonId) {
        return {
          background: season.color,
        };
      } else {
        return {
          color: season.color,
        };
      }
    },
    getItemStyleObject(id) {
      if (id === this.selectedItemId) {
        return {
          background: this.selectedSeason.color,
        };
      } else {
        return {
          color: this.selectedSeason.color,
        };
      }
    },

    onClickArea() {
      if (this.isShowAreaFrame) {
        this.isShowAreaFrame = false;
      } else {
        this.isShowAreaFrame = true;
      }
    },

    isItemDetailAuto(workItemDetail) {
      if (this.isNotPaddyFieldItem) {
        return false;
      }
      if (this.selectedPaddyField.area && workItemDetail.item_detail_auto) {
        return true;
      }
      return false;
    },

    getItemDetailAutoValue(itemDetailId, workHistory) {
      if (this.isNotPaddyFieldItem) {
        return "";
      }
      if (workHistory.work_items_auto) {
        const val = workHistory.work_items_auto[itemDetailId];
        if (val != null) {
          return val;
        }
      }
      return "";
    },

    getItemDetailUnit(workItemDetail) {
      let unit = workItemDetail.item_detail_unit;
      if (!unit) {
        unit = "";
      }
      return unit;
    },

    getItemDetailAutoUnit(workItemDetail) {
      if (this.isItemDetailAuto(workItemDetail)) {
        if (this.selectedPaddyField.area) {
          const unit = this.getItemDetailUnit(workItemDetail);
          return unit + "/10a";
        }
      }
      return "";
    },

    async onClickSearchWorkHistories() {
      await this.loading(async () => {
        // 作業実績一覧をクリア
        this.workHistories = [];
        // マーカーの選択をクリア
        this.clearMarkerSelection();
        this.selectedPaddyField = null;
        // 作業分類・作業項目の選択をクリア
        this.selectedItemId = null;
        this.selectedSeasonId = null;

        const result = await this.searchWorkHistories(this.searchCriteria);

        if (result.listPaddy.length === 0 && result.listNotPaddy.length === 0) {
          this.searchResult.listPaddy = [];
          this.searchResult.globalWorkHistories = [];
          this.showMessage("検索条件と一致する作業履歴が見つかりません。");
        } else {
          // 検索結果データを加工して画面表示
          // ほ場作業
          for (const it of result.listPaddy) {
            it.workHistories = await this.organizeWorkHistories(
              it.workHistories,
              null,
              false
            );
          }
          this.searchResult.listPaddy = result.listPaddy;

          // ほ場外作業
          const globalWorkHistories = [];
          for (const it of result.listNotPaddy) {
            const list = await this.organizeWorkHistories(
              it.workHistories,
              null,
              false
            );
            globalWorkHistories.push(list);
          }
          this.searchResult.globalWorkHistories = globalWorkHistories.flat();
        }
      });
    },

    /**
     * 作業履歴の整理。workHistoriesには破壊的変更が入るが、処理結果は戻り値の方が正しい。
     * workHistoriesに不足情報を追加し、実施日の降順にソートして返す。
     *
     * 追加する情報は、
     * １．workHistoriesのwork_itemsを基にした、作業項目詳細を追加したwork_items_merged
     * ２．workHistoriesのimage_pathsを基にした、一時的な画像URLであるimage_urls
     *
     * なおitemが無指定の場合は、対応する作業項目マスタが存在しない作業履歴は除外して返却される。
     *
     * @param {{season_id: number, item_id: number, work_items: Array, image_paths: Array<string>}[]} workHistories 作業履歴またはほ場外作業履歴のリスト
     * @param {Object} item ほ場外作業などでworkHistoriesの全ての作業履歴に対応する作業項目マスタがあれば指定する。(デフォルトはnull)
     * @param {boolean} sort workHistoriesを実施日の降順にソートするかどうかを指定する。ソートしない場合はfalse。(デフォルトはtrue)
     * @return {{season_id: number, item_id: number, work_items: Array, image_paths: Array<string>, work_items_merged: Array, image_urls: Array<string>}[]}
     *          workHistoriesを画面表示用に整理したリスト。
     */
    async organizeWorkHistories(workHistories, item = null, sort = true) {
      // 作業履歴に作業項目の詳細情報をマージする
      for (const workHistory of workHistories) {
        // workHistory.itemへ作業項目マスタをセットする
        if (item) {
          workHistory.item = item;
        } else {
          // 対応する作業項目マスタを取得
          const _season = this.seasons.find(
            (e) => e.season_id === workHistory.season_id
          );
          if (_season) {
            const _item = _season.items.find(
              (e) => e.item_id === workHistory.item_id
            );
            workHistory.item = _item;
          }
        }

        // 作業項目マスタのitem_detailsと同じ並び順でwork_items_mergedへ追加していく
        workHistory.work_items_merged = [];
        if (workHistory.item) {
          workHistory.item.item_details.forEach((itemDetail) => {
            if (workHistory.work_items[itemDetail.item_detail_id]) {
              workHistory.work_items_merged.push({
                ...itemDetail,
                value: workHistory.work_items[itemDetail.item_detail_id],
              });
            }
          });
        }

        // 画像URLを生成しimage_urlsへ追加していく
        workHistory.image_urls = [];
        if (workHistory.image_paths) {
          for (const path of workHistory.image_paths) {
            const url = await Storage.get(path);
            workHistory.image_urls.push(url);
          }
        }
      }

      // 作業項目マスタを特定できなかったデータはフィルタする
      workHistories = workHistories.filter((workHistory) => workHistory.item);

      if (sort) {
        // 作業履歴を実施日の降順にソートする
        workHistories = workHistories.sort((a, b) => {
          const aExecDate = a.work_items_merged.find(
            (e) => e.display_flg === true
          ).value;
          const bExecDate = b.work_items_merged.find(
            (e) => e.display_flg === true
          ).value;
          if (aExecDate > bExecDate) return -1;
          if (aExecDate < bExecDate) return 1;
          return 0;
        });
      }

      return workHistories;
    },

    clearSearchDialog() {
      // 作業検索画面を消して検索結果をクリア
      this.isShowSearchFrame = false;
      this.searchResult.listPaddy = [];
      this.searchResult.globalWorkHistories = [];
      if (this.searchResult.centeredMarker) {
        this.searchResult.centeredMarker.setIcon(
          this.buildMarkerIconProps(this.searchResult.centeredMarker, true)
        );
      }
      this.searchResult.centeredMarker = null;
    },

    onClickSearchResultHeader(paddyField) {
      // マーカーオブジェクトを特定
      const marker = this.markers.find((m) => {
        return m.get("paddyField").paddy_field_id === paddyField.paddy_field_id;
      });

      // 同じヘッダ行を連続クリックした場合はマーカーを何も変えない
      if (
        !this.searchResult.centeredMarker ||
        marker.get("paddyField").paddy_field_id !==
          this.searchResult.centeredMarker.get("paddyField").paddy_field_id
      ) {
        // マーカーの選択状態を反転
        marker.setIcon(this.buildMarkerIconProps(marker, true));

        if (this.searchResult.centeredMarker) {
          // 前に選択したヘッダ行のマーカーも反転
          this.searchResult.centeredMarker.setIcon(
            this.buildMarkerIconProps(this.searchResult.centeredMarker, true)
          );
        }

        this.searchResult.centeredMarker = marker;
      }

      // マーカーをセンタリング
      marker.getMap().setCenter(marker.getPosition());
    },
  },
};
</script>

<style lang="scss">
// @import "../constants/constants.scss";

$side-frame-width: 350px;

.work-history-show {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    .mobile & {
      height: 0;

      #info {
        position: fixed;
        align-items: center;
        background: rgba(83, 54, 155, 0.8);
        margin: 48px 0 0 0;
        width: 100%;
        height: 33px;
        text-align: center;
        color: #fff;
        font-size: 0.7rem;
        display: none;
        opacity: 0;
        transition: opacity 0.3s;
      }
      #info.active {
        display: grid;
        z-index: 21;
        opacity: 1;
      }

      #select-box {
        width: 90%;
        height: 30px;
        color: #333;
        font-size: 0.8rem;
        text-align: center;
        position: fixed;
        bottom: 65px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        display: none;
        align-items: center;
        border-radius: 15px;
        box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.3);
        z-index: 20;
      }
      #select-box.active {
        display: grid;
      }
      #next-btn {
        width: 100%;
        height: 50px;
        text-align: center;
        background: rgba(83, 54, 155, 0.8);
        position: fixed;
        bottom: 0;
        left: 0;
        display: none;
        align-items: center;
        cursor: pointer;
        z-index: 30;
      }
      #next-btn.active {
        display: grid;
      }
      #next-btn span {
        color: #fff;
        font-size: 1rem;
      }
      #next-btn span::before {
        white-space: pre;
        content: "    ";
        display: inline-block;
        background: url("~@/assets/icons/ic_next.svg") no-repeat left -2px;
        width: 26px;
        height: 20px;
        background-size: contain;
        vertical-align: middle;
      }

      #item-edit-area {
        // display: flex;
        // justify-content: flex-start;
        width: 60px;
        // position: fixed;
        text-align: center;
        background: rgba(256, 256, 256);
        margin: 90px 10px 10px auto;
        height: 60px;
        border-radius: 40px;
      }
      #item-edit-area span {
        display: block;
        font-size: 28px;
        // padding: 3px 0px;
        // margin: 10px 0;
        // text-align: center;
        color: var(--purple);
        // margin: 8px 15px;
        padding: 10px;
      }

      #item-edit-area span.active {
        // border-bottom: solid 4px var(--purple);
        cursor: pointer;
      }

      #item-edit-area span::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
        // background-size: 20px 20px;
        // padding: 0 0 0 15px;
      }
    }
  }
  .filter-area-left {
    display: flex;
    // width: auto;
    // height: auto;
    position: absolute;

    // div {
    //   display: block;
    //   border-radius: 20%;
    //   background: white;
    //   height: 30px;
    //   margin: 10px;
    //   text-align: center;
    // }
    .filter-icon-work {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_filter_work.svg") no-repeat
        center center;
      margin: 15px;
      cursor: pointer;
    }
    .filter-icon-location {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_filter_location.svg") no-repeat
        center center;
      margin: 15px;
      cursor: pointer;
    }
    .filter-icon-paddy {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_filter_paddy.svg") no-repeat
        center center;
      margin: 15px;
      cursor: pointer;
    }
    .filter-icon-search {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_filter_search.svg") no-repeat
        center center;
      margin: 15px;
      cursor: pointer;
    }
    // .filter-icon {
    //   display: block;
    // }
    // .filter-icon::before {
    //   white-space: pre;
    //   content: "   ";
    //   background: url("~@/assets/icons/ic_rate-review.svg") no-repeat center
    //     center;
    //   background-size: 20px 20px;
    //   padding: 10px;
    // }
  }
  .filter-area-right {
    position: absolute;
    top: 0;
    right: 0;
    width: 45px;
    padding: 20px 20px 0 0;

    .filter-icon {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: white url("~@/assets/icons/ic_rate-review.svg") no-repeat
        center center;
      cursor: pointer;
    }
  }

  .top-frame-container {
    width: 100%;
    max-width: 510px;
    //   padding: 30px;
    position: absolute;
    top: 30px;
    left: 30px;
    transition: height 0.5s;

    .mobile & {
      top: 0px;
      left: 0px;
    }

    .top-frame {
      // width: 100%;
      // max-width: 480px;
      // min-width: 350px;
      min-height: 100px;
      padding: 20px;
      // margin-right: $side-frame-width;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      transition: height 0.5s;

      .mobile & {
        height: 100vh;
        width: 100%;
        position: absolute;
        top: 0;
        border-radius: unset;
        z-index: 50;
        display: block;
        padding: unset;
      }
    }

    .top-frame .title-area {
      border-bottom: none;
      display: grid;
      grid-template-columns: 1fr 200px;
      align-items: center;
      margin: 0;
      padding: 0;

      .mobile & {
        font-size: 0.9em;
        width: 100%;
        height: 60px;
        padding: 15px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 32px;
        align-items: center;
        border-bottom: solid 1px #ddd;

        h3 {
          margin: 0;
          padding: 0 0 0 40px;
          display: flex;
          align-items: center;
        }

        h3 span {
          width: 25px;
          height: 45px;
          display: inline-block;
          margin: 0 10px 0 0;
        }

        .btn-close {
          cursor: pointer;
          width: 32px;
          height: 32px;
          background: url("~@/assets/icons/ic_cancel.svg") no-repeat center
            center;
          background-size: contain;
        }
      }

      h3 {
        background: url("~@/assets/icons/ic_flag.svg") no-repeat left center;
        background-size: 30px 30px;
      }
    }
    .top-frame h3 {
      padding: 0 0 0 2em;
      margin: 0px 15px 15px 15px;
    }
    .top-frame .selectCal {
      text-align: right;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }

    .top-frame .selectCal:active {
      opacity: 0.5;
      /* transition: 0.5s; */
    }

    .arrow-left {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      margin: 0 10px 0 0;
      cursor: pointer;
    }

    .arrow-left:active {
      transform: scale(1.2);
    }

    .arrow-right {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      transform: rotate(180deg);
      margin: 0 0 0 10px;
      cursor: pointer;
    }

    .arrow-right:active {
      transform: scale(1.2);
    }

    .top-frame .filter {
      text-align: right;
      display: block;
      cursor: pointer;
      font-size: 14px;
      margin: 0 20px 0 0;
      padding: 0;
      text-decoration: none;
      color: var(--purple);
    }

    .top-frame .filter::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_sort.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 20px;
    }

    .top-frame .filter:active {
      opacity: 0.5;
    }

    input[type="radio"] {
      display: none;
    }

    .input-frame-wrap {
      max-height: 500px;
      display: block;
      overflow: hidden;
      transition: ease-in-out 0.3s;
    }

    .input-frame {
      display: grid;
      grid-template-columns: repeat(auto-fill, 120px);
      justify-content: center;
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 15px 0 0 0;
      .mobile & {
        grid-template-columns: repeat(auto-fill, 30%);
        max-height: calc((100vh - 160px) / 3);
        overflow: scroll;
        padding: 10px;
      }
    }
    .input-frame-wrap.close {
      max-height: 0px;
      transition: ease-in-out 0.3s;
    }

    .input-frame-B {
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, 120px);
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      background: #eee;
      padding: 20px;
      margin: 20px 0 0 0;
      border-radius: 20px;
      border: solid 1px #ccc;
      .mobile & {
        grid-template-columns: repeat(auto-fill, 30%);
        border-radius: unset;
        max-height: calc((100vh - 160px) / 3 * 2);
        overflow: scroll;
        padding: 10px;
      }
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .mobile & {
        overflow: unset;
        text-overflow: unset;
        white-space: unset;
        overflow-wrap: break-word;
      }
    }

    input[type="radio"]:checked + .col1 {
      background: var(--col1);
      color: #fff;
    }

    input[type="radio"]:checked + .col2 {
      // background: var(--col2);
      color: #fff;
    }
    input[type="radio"]:checked + .col3 {
      // background: var(--col3);
      color: #fff;
    }
    input[type="radio"]:checked + .col4 {
      background: var(--col4);
      color: #fff;
    }
    .item-summary {
      display: flex;
      justify-content: space-around;
    }
    .select-button {
      display: block;
      width: 200px;
      margin: 20px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 20px;
      background: var(--purple);
      color: #fff;
      cursor: pointer;
      user-select: none;
      &#selectFlagButton::before {
        white-space: pre;
        content: "    ";
        margin: 0 10px 0 0;
        background: url("~@/assets/icons/ic_expand.svg") no-repeat center center;
      }
      &:active {
        opacity: 0.5;
      }
      &#selectItemButton {
        margin: 0;
        width: 170px;
      }
    }
    .navigate-button {
      display: block;
      width: 200px;
      margin: 0px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px 0px 20px;
      border-radius: 20px;
      background: transparent;
      color: #000;
      cursor: default;
      user-select: none;
      &::before {
        white-space: pre;
        content: "    ";
        margin: 0 10px 0 0;
        background: url("~@/assets/icons/ic-expand-more.svg") no-repeat center
          center;
      }
    }

    .selection-frame {
      display: grid;
      grid-template-columns: 120px 120px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 7px 0 7px 0;
    }
  }
  .filter-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .mobile & {
      top: 0;
    }

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;

      .mobile & {
        width: 100%;
        height: 100vh;
        padding: 15px;
        max-width: unset;
        max-height: unset;
        top: 0;
        border-radius: unset;
        box-shadow: unset;
      }

      /* フォーム */

      .label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .mobile & {
          overflow: unset;
          text-overflow: unset;
          white-space: unset;
          overflow-wrap: break-word;
        }
      }

      input[type="radio"]:checked + .col1 {
        background: var(--col1);
        color: #fff;
      }

      input[type="radio"]:checked + .col2 {
        // background: var(--col2);
        color: #fff;
      }
      input[type="radio"]:checked + .col3 {
        // background: var(--col3);
        color: #fff;
      }
      input[type="radio"]:checked + .col4 {
        background: var(--col4);
        color: #fff;
      }
      input[type="text"],
      input[type="date"],
      input[type="number"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus,
      input[type="number"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }

    .top-frame .title-area {
      border-bottom: none;
      display: grid;
      grid-template-columns: 1fr 200px;
      align-items: center;
      margin: 0;
      padding: 0;

      .mobile & {
        font-size: 0.9em;
        width: 100%;
        height: 60px;
        padding: 15px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 32px;
        align-items: center;
        border-bottom: solid 1px #ddd;

        h3 {
          margin: 0;
          padding: 0 0 0 40px;
          display: flex;
          align-items: center;
        }

        h3 span {
          width: 25px;
          height: 45px;
          display: inline-block;
          margin: 0 10px 0 0;
        }

        .btn-close {
          cursor: pointer;
          width: 32px;
          height: 32px;
          background: url("~@/assets/icons/ic_cancel.svg") no-repeat center
            center;
          background-size: contain;
        }
      }

      .title-icon-work {
        background: url("~@/assets/icons/ic_filter_work.svg") no-repeat left
          center;
        background-size: 30px 30px;
      }
      .title-icon-location {
        background: url("~@/assets/icons/ic_filter_location.svg") no-repeat left
          center;
        background-size: 30px 30px;
      }
    }
    .top-frame h3 {
      padding: 0 0 0 2em;
      margin: 0px 15px 15px 15px;
    }
    .top-frame .selectCal {
      text-align: right;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }

    .top-frame .selectCal:active {
      opacity: 0.5;
      /* transition: 0.5s; */
    }

    .arrow-left {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      margin: 0 10px 0 0;
      cursor: pointer;
    }

    .arrow-left:active {
      transform: scale(1.2);
    }

    .arrow-right {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      transform: rotate(180deg);
      margin: 0 0 0 10px;
      cursor: pointer;
    }

    .arrow-right:active {
      transform: scale(1.2);
    }

    .top-frame .filter {
      text-align: right;
      display: block;
      cursor: pointer;
      font-size: 14px;
      margin: 0 20px 0 0;
      padding: 0;
      text-decoration: none;
      color: var(--purple);
    }

    .top-frame .filter::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_sort.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 20px;
    }

    .top-frame .filter:active {
      opacity: 0.5;
    }

    input[type="radio"] {
      display: none;
    }

    .input-frame-wrap {
      max-height: 500px;
      display: block;
      overflow: hidden;
      transition: ease-in-out 0.3s;
    }

    .input-frame {
      display: grid;
      grid-template-columns: repeat(auto-fill, 120px);
      justify-content: center;
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 15px 0 0 0;
      .mobile & {
        grid-template-columns: repeat(auto-fill, 30%);
        max-height: calc((100vh - 160px) / 3);
        overflow: scroll;
        padding: 10px;
      }
    }
    .input-frame-wrap.close {
      max-height: 0px;
      transition: ease-in-out 0.3s;
    }

    .input-frame-B {
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, 120px);
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      background: #eee;
      padding: 20px;
      margin: 20px 0 0 0;
      border-radius: 20px;
      border: solid 1px #ccc;
      .mobile & {
        grid-template-columns: repeat(auto-fill, 30%);
        border-radius: unset;
        max-height: calc((100vh - 160px) / 3 * 2);
        overflow: scroll;
        padding: 10px;
      }
    }

    .input-frame-wrap .location-date {
      display: grid;
      grid-template-columns: 200px 100px 20px 100px;
      text-align: center;
      align-items: center;
      grid-column-gap: 20px;
      padding: 15px 0;
    }

    .input-frame-C {
      display: grid;
      grid-template-columns: auto auto auto;
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 15px 0;

      .user-info {
        display: flex;
        max-width: 220px;
      }

      .user-color {
        width: 15px;
        height: 15px;
        min-width: 15px;
        min-height: 15px;
        margin: auto 0;
        border-radius: 50%;
      }
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      .mobile & {
        overflow: unset;
        text-overflow: unset;
        white-space: unset;
        overflow-wrap: break-word;
      }
    }

    input[type="radio"]:checked + .col1 {
      background: var(--col1);
      color: #fff;
    }

    input[type="radio"]:checked + .col2 {
      // background: var(--col2);
      color: #fff;
    }
    input[type="radio"]:checked + .col3 {
      // background: var(--col3);
      color: #fff;
    }
    input[type="radio"]:checked + .col4 {
      background: var(--col4);
      color: #fff;
    }
    .item-summary {
      display: flex;
      justify-content: space-around;
    }
    .select-button {
      display: block;
      width: 200px;
      margin: 20px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 20px;
      background: var(--purple);
      color: #fff;
      cursor: pointer;
      user-select: none;
      &#selectFlagButton::before {
        white-space: pre;
        content: "    ";
        margin: 0 10px 0 0;
        background: url("~@/assets/icons/ic_expand.svg") no-repeat center center;
      }
      &:active {
        opacity: 0.5;
      }
      &#selectItemButton {
        margin: 0;
        width: 170px;
      }
    }
    .navigate-button {
      display: block;
      width: 200px;
      margin: 0px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px 0px 20px;
      border-radius: 20px;
      background: transparent;
      color: #000;
      cursor: default;
      user-select: none;
      &::before {
        white-space: pre;
        content: "    ";
        margin: 0 10px 0 0;
        background: url("~@/assets/icons/ic-expand-more.svg") no-repeat center
          center;
      }
    }

    .selection-frame {
      display: grid;
      grid-template-columns: 120px 120px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 7px 0 7px 0;
    }
    .button-area {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      .mobile & {
        padding: 10px 0;
      }

      .right-box {
        right: 0;
        bottom: 0;
        width: 70px;
      }
      .center-box {
        display: inline;
        text-align: center;
        width: calc(100% - 140px);

        .mobile & {
          width: calc(100% - 70px);
        }
      }
      .left-box {
        left: 0;
        bottom: 0;
        width: 70px;
        .mobile & {
          width: unset;
        }
      }

      .btn {
        display: inline-block;
        background: white;
        font-size: 14px;
        text-align: center;
        width: 130px;
        height: 30px;
        border-radius: 15px;
        color: var(--purple);
        padding: 6px 20px;
        margin: 10px auto 10px;
        cursor: pointer;
        &.disable {
          opacity: 0.5;
          cursor: inherit;
          pointer-events: none;
        }
        &.btn-submit {
          background: var(--purple);
          color: #fff;
          margin-left: 3px;
          margin-right: 3px;
        }
        &.btn-cancel {
          background: var(--purple-tertiary);
          color: #000;
          margin-left: 3px;
          margin-right: 3px;
        }

        .mobile & {
          width: unset;
          min-width: 100px;
        }
      }

      .text {
        right: 0;
        bottom: 0;
        display: block;
        font-size: 14px;
        padding: 3px 0px;
        margin: 10px 0;
        text-align: center;
        color: var(--purple);
        border-bottom: solid 4px transparent;
        opacity: 0.5;
        pointer-events: none;
      }
      .text.active {
        border-bottom: solid 4px var(--purple-secondary);
        opacity: 1;
        cursor: pointer;
        pointer-events: inherit;
      }
      .text::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
        background-size: 20px 20px;
        padding: 0 0 0 5px;
      }
    }
  }

  .col1 {
    display: inline-block;
    text-align: center;
    color: var(--col1);
    border: 1px solid var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col1-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col1);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col2 {
    display: inline-block;
    text-align: center;
    // color: var(--col2);
    // border: 1px solid var(--col2);
    border: 1px solid;
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
    .mobile & {
      width: 100%;
    }
  }

  .col2-fill {
    display: inline-block;
    text-align: center;
    // color: white;
    // background: var(--col2);
    border: 1px solid;
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col3 {
    display: inline-block;
    text-align: center;
    // color: var(--col3);
    // border: 1px solid var(--col3);
    border: 1px solid;
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
    .mobile & {
      width: 100%;
    }
  }
  .col3-fill {
    display: inline-block;
    text-align: center;
    color: white;
    // background: var(--col3);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .col4 {
    display: inline-block;
    text-align: center;
    color: var(--col4);
    border: 1px solid var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }
  .col4-fill {
    display: inline-block;
    text-align: center;
    color: white;
    background: var(--col4);
    padding: 4px;
    cursor: pointer;
    font-size: 13px;
    border-radius: 30px;
  }

  .ricelog_pinicon_010 {
    background: url("~@/assets/pin/ricelog_pinicon_010.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_020 {
    background: url("~@/assets/pin/ricelog_pinicon_020.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_030 {
    background: url("~@/assets/pin/ricelog_pinicon_030.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_040 {
    background: url("~@/assets/pin/ricelog_pinicon_040.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_050 {
    background: url("~@/assets/pin/ricelog_pinicon_050.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_060 {
    background: url("~@/assets/pin/ricelog_pinicon_060.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_070 {
    background: url("~@/assets/pin/ricelog_pinicon_070.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_080 {
    background: url("~@/assets/pin/ricelog_pinicon_080.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_090 {
    background: url("~@/assets/pin/ricelog_pinicon_090.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .ricelog_pinicon_100 {
    background: url("~@/assets/pin/ricelog_pinicon_100.png") no-repeat center
      center;
    background-size: 25px 45px;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .mobile & {
      top: 0;
    }

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;

      .mobile & {
        width: 100%;
        height: 100vh;
        padding: 15px;
        max-width: unset;
        max-height: unset;
        top: 0;
        border-radius: unset;
        box-shadow: unset;
      }
    }
    //   &.active {
    //     display: flex;
    //     /* animation: scaleAnimIn 0.3s ease-out; */
    //   }

    .title-area {
      width: 100%;
      height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;

      .mobile & {
        height: 60px;
      }
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
      min-width: 25px;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    #edit-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #edit-area span {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }

    #edit-area span.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }

    #edit-area span::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }

    .section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        dl.columns {
          width: 100%;
          display: grid;
          grid-template-columns: 200px 1fr;
          align-items: top;
          grid-gap: 0px 0px;
          margin: 0;
          padding: 0;
          font-size: 16px;
          color: #333;
          .mobile & {
            grid-template-columns: 1fr 1.5fr;
          }
        }

        .columns dt {
          display: block;
          text-align: right;
          width: 100%;
          margin: 0;
          padding: 16px;
        }

        .columns dd {
          display: block;
          width: 100%;
          border-left: solid 1px #ddd;
          margin: 0;
          padding: 16px;

          .input-with-unit {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .unit {
              margin-left: 1rem;
              word-break: keep-all;
            }
            input {
              width: auto;
              flex-grow: 2;
            }
          }

          span.textarea {
            white-space: pre-line;
          }
          .input-with-user {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // margin: 0 0 10px 0;

            .label {
              padding: 0 0 0 5px;
              cursor: pointer;
            }
            .label::before {
              white-space: pre;
              content: "    ";
              background: url("~@/assets/icons/ic_add_circle.svg") no-repeat
                center center;
              background-size: 20px 20px;
              padding: 0 0 0 15px;
            }
          }
        }
        // .columns dt:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }
        // .columns dd:nth-of-type(odd) {
        //   background: #f3f3f3;
        // }

        /* フォーム */

        input[type="text"],
        input[type="date"],
        input[type="number"] {
          width: 100%;
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 16px;
          font-size: 16px;
          outline: none;
        }

        input[type="text"]:focus,
        input[type="date"]:focus,
        input[type="number"]:focus {
          background: var(--purple-tertiary);
        }

        select {
          height: 40px;
          border-radius: 20px;
          border: solid 1px var(--purple);
          padding: 0 38px 0 16px;
          font-size: 16px;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center;
          background-size: 25px 25px;
        }

        select:focus {
          background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
            calc(100% - 10px) center var(--purple-tertiary);
          background-size: 25px 25px;
        }

        textarea {
          font-size: 16px;
          width: 100%;
          min-height: 200px;
          white-space: pre-wrap;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border: solid 1px var(--purple);
          padding: 10px;
          border-radius: 10px 10px 0 10px;
          font-family: inherit;
        }

        textarea:focus {
          background: var(--purple-tertiary);
        }

        input[type="radio"] {
          display: none;
        }
        input[type="radio"] + label {
          padding: 0 20px 0 0;
        }
        input[type="radio"]:disabled + label {
          color: #aaa;
        }

        input[type="radio"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
            left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="radio"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
        input[type="radio"]:disabled + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
            center left;
          background-size: 24px 24px;
          display: inline-block;
        }

        input[type="checkbox"] {
          display: none;
        }
        input[type="checkbox"] + label {
          padding: 0 20px 0 0;
        }

        input[type="checkbox"] + label:before {
          display: inline-block;
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat
            center left;
          background-size: 24px 24px;
          padding: 0 16px 0 0;
        }
        input[type="checkbox"]:checked + label:before {
          white-space: pre;
          content: "    ";
          background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
            left;
          background-size: 24px 24px;
          display: inline-block;
        }
      }
    }
    .button-area {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      .mobile & {
        padding: 10px 0;
      }

      .right-box {
        right: 0;
        bottom: 0;
        width: 70px;
      }
      .center-box {
        display: inline;
        text-align: center;
        width: calc(100% - 140px);

        .mobile & {
          width: calc(100% - 70px);
        }
      }
      .left-box {
        left: 0;
        bottom: 0;
        width: 70px;
        .mobile & {
          width: unset;
        }
      }

      .btn {
        display: inline-block;
        background: white;
        font-size: 14px;
        text-align: center;
        width: 130px;
        height: 30px;
        border-radius: 15px;
        color: var(--purple);
        padding: 6px 20px;
        margin: 10px auto 10px;
        cursor: pointer;
        &.disable {
          opacity: 0.5;
          cursor: inherit;
          pointer-events: none;
        }
        &.btn-submit {
          background: var(--purple);
          color: #fff;
          margin-left: 3px;
          margin-right: 3px;
        }
        &.btn-cancel {
          background: var(--purple-tertiary);
          color: #000;
          margin-left: 3px;
          margin-right: 3px;
        }

        .mobile & {
          width: unset;
          min-width: 100px;
        }
      }

      .text {
        right: 0;
        bottom: 0;
        display: block;
        font-size: 14px;
        padding: 3px 0px;
        margin: 10px 0;
        text-align: center;
        color: var(--purple);
        border-bottom: solid 4px transparent;
        opacity: 0.5;
        pointer-events: none;
      }
      .text.active {
        border-bottom: solid 4px var(--purple-secondary);
        opacity: 1;
        cursor: pointer;
        pointer-events: inherit;
      }
      .text::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
        background-size: 20px 20px;
        padding: 0 0 0 5px;
      }
    }
    #upload-area {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    #upload-area label {
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;

      > input[type="file"] {
        display: none;
      }
    }

    #upload-area label.active {
      border-bottom: solid 4px var(--purple);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }

    #upload-area label::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_upload.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 15px;
    }

    .upload-area-view {
      width: 100%;

      span {
        position: absolute;
      }
      span.active {
        opacity: 1;
        cursor: pointer;
        pointer-events: inherit;
      }
      span::before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_clear.svg") no-repeat center center;
        background-size: 30px 30px;
        padding: 0 0 0 15px;
      }

      img {
        max-width: 100%;
        margin: 10px 0px;
      }
    }
  }

  .search-frame.center-frame-container {
    margin: 0;
    padding: 0;
    width: 350px;
    height: unset;
    top: 30px;
    left: 30px;
    z-index: 80;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 100%;
      max-width: unset;
      max-height: unset;
      position: relative;
      top: 0;

      .center-frame-header {
        display: grid;
        grid-template-columns: 1fr 32px;

        .title-icon-search {
          display: flex;
          align-items: center;
          margin: 0 0 15px 0;
          padding: 0 0 0 35px;
          background: url("~@/assets/icons/ic_filter_search.svg") no-repeat left
            center;
          background-size: 30px 30px;
        }
      }

      .center-frame-content {
        .button-area {
          display: grid;
          grid-template-columns: 1fr 1fr 70px;

          .right-box {
            width: 100%;

            .btn {
              width: 70px;
              margin-left: 0;
              margin-right: 0;
            }
          }
        }
      }
    }
  }

  .image-frame-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 95;

    .image-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      height: 80vh;
      // max-height: 80vh;
      // overflow-y: scroll;
      position: absolute;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    .image-title-area {
      width: 100%;
      height: 60px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      // border-bottom: solid 1px #ddd;
    }

    .image-footer-area {
      width: 100%;
      height: 20px;
      padding: 0;
      // border-top: solid 1px #ddd;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    .section {
      // overflow: auto;
      width: 100%;
      height: calc(100% - 80px);
      position: relative;

      .container {
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;

        img {
          margin: auto;
          max-width: 100%;
          max-height: 100%;
          display: block;
        }
      }
    }
  }
  .area-frame-container {
    position: absolute;
    display: flex;
    margin: 20px;
    // padding: 30px;
    top: 100px;
    // box-sizing: border-box;
    // background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    // background: white;
    // font-size: 0.8rem;
    max-width: 350px;
    // max-height: 50vh;
    min-width: 270px;
    min-height: 100px;

    .area-frame {
      width: 100%;
      padding: 0px;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
    }

    .area-frame-header {
      width: 100%;
      height: 60px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 50px;
      align-items: center;
      // border-bottom: solid 1px #ddd;
      border-radius: 20px 20px 0 0;
      background: #ddd;
    }

    .area-frame-header h4 {
      font-size: 20px;
      font-weight: bold;
      margin: 0 auto 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    // .title-area h3 span {
    //   width: 25px;
    //   height: 45px;
    //   display: inline-block;
    //   margin: 0 10px 0 0;
    //   min-width: 25px;
    // }

    .btn-close {
      cursor: pointer;
      width: 24px;
      height: 24px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }

    .area-frame-content {
      // margin: 10px 20px;
      font-size: 14px;
      overflow: scroll;
      max-height: calc(100vh - 280px);

      table {
        width: 100%;

        tr {
          line-height: 1.75rem;
          &:nth-of-type(n + 2) {
            border-top: solid 1px darkgray;
          }
        }
        td {
          padding-right: 5px;
        }
        // .label {
        // text-align: right;
        // max-width: 50%;
        // }
        .unit {
          text-align: right;
          white-space: nowrap;
          padding: 0 0 0 10px;
        }
        .value {
          // min-width: 6rem;
          white-space: nowrap;
          text-align: right;
          padding: 0 0 0 10px;
        }
      }
      ul {
        list-style: none;
        padding: 0;
      }
    }

    .area-frame-footer {
      width: 100%;
      height: 40px;
      background: #ddd;
      border-radius: 0 0 20px 20px;
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .scale-enter,
  .scale-leave-to {
    transform: scale(0.5);
    opacity: 0;
  }
  .scale-enter-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-out;
  }
  .scale-leave-active {
    transition: transform 0.25s, opacity 0.25s;
    transition-timing-function: ease-in;
  }

  /* アニメーション */

  @keyframes scaleAnimIn {
    0% {
      display: flex;
      transform: scale(0.5);
    }
    100% {
      display: flex;
      transform: scale(1);
    }
  }

  @keyframes fadeAnimIn {
    0% {
      display: grid;
      opacity: 0;
    }
    100% {
      display: grid;
      opacity: 1;
    }
  }
}
</style>
